import { QuickReply } from './QuickReply'

export default QuickReply
